<template>
  <div
    class="supernavbar-menu"
    :class="{ [variant]: true, 'under-top-banner':topBannerShown }"
  >
    <div class="menu-header">
      <div class="qrw-heading-xs bold qrw-text-content-base-inverse-primary">
        {{ $t("navbar_pages." + (page || {}).name) }}
      </div>
      <BaseIconButton
        size="md"
        icon="sidebar-menu"
        variant="ghost"
        textColor="content-base-inverse-secondary"
        hoverColor="background-overlay-a10"
        textHoverColor="content-base-inverse-primary"
        @click="toggleNavbarCollapse"
      />
    </div>

    <div
      class="menu-content"
      v-if="page && !page.special"
    >
      <div
        class="menu-section"
        :class="{
          'full-height': section.fullHeight
        }"
        v-for="(section, index) in uiSections"
        :key="index"
      >
        <div
          class="menu-section-name qrw-label-sm bold"
          v-if="section.section_title"
        >
          {{ section.section_title }}
        </div>
        <template v-for="(child, child_index) in section.section_items">
          <BaseDivider
            color="border-base-inverse-tertiary"
            v-if="child.divider"
          />
          <NavbarSidemenuLink
            :target="child"
            @click="$emit('linkClicked', child)"
            :key="child_index"
            v-else
          />
        </template>
      </div>

      <div
        class="version-container"
        v-if="page && page.name === 'profile'"
      >
        <div class="qrw-label-sm bold qrw-text-content-base-inverse-primary">
          Admin Panel
        </div>
        <div class="qrw-label-xs qrw-text-content-base-inverse-primary">
          v.3.1.0
        </div>
      </div>
    </div>
    <div
      class="menu-content"
      v-else-if="page && page.special == 'workspace'"
    >
      <NavbarWorkspaceSwitcher />
    </div>
  </div>
</template>

<script>
import NavbarSidemenuLink from '@/components/supernavbar/NavbarSidemenuLink.vue'
import NavbarWorkspaceSwitcher from '@/components/supernavbar/NavbarWorkspaceSwitcher.vue'

export default {
  props: {
    variant: String,
    page: Object,
    contentType: String,
    topBannerShown: Boolean
  },
  components: {
    NavbarSidemenuLink,
    NavbarWorkspaceSwitcher
  },
  methods: {
    toggleNavbarCollapse() {
      const newValue = !this.isNavbarCollapsed
      this.$store.commit('ui/setNavbarCollapsed', newValue)

      if (!newValue) {
        window.localStorage.removeItem('navbar_collapsed')
      } else {
        window.localStorage.setItem('navbar_collapsed', Date.now())
      }
    }
  },
  computed: {
    isNavbarCollapsed() {
      return this.$store.state.ui.navbar_collapsed
    },
    uiSections() {
      let sections = []
      let lastSection = {
        section_title: null,
        section_items: []
      }

      for (const child of this.page.children) {
        if (child.section_title) {
          if (lastSection.section_items.length) {
            sections.push(lastSection)
          }

          lastSection = {
            section_title: child.section_title,
            section_items: []
          }
        } else {
          lastSection.section_items.push(child)
        }
      }

      sections.push(lastSection)

      return sections
    }
  }
}
</script>

<style scoped>
.supernavbar-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  width: 256px;
}

.supernavbar-menu.overlay {
  background: var(--qrw-background-base-inverse-primary-08);
  backdrop-filter: blur(20px);
  border-radius: 0 12px 12px 0;

  position: fixed;
  top: 0;
  left: 64px;

  z-index: 20;
}

.supernavbar-menu.overlay.under-top-banner {
  top: 44px;
  height: calc(100% - 44px);
}

.supernavbar-menu.solid {
  background: var(--foundation-gray-900-color);
  position: relative;
  z-index: 20;
  /* animation: 0.3s appear ease-in-out; */
  border-radius: 12px 0px 0px 12px;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  column-gap: 12px;
  align-items: center;
}

.menu-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-section {
  row-gap: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
}

.menu-section.full-height {
  height: 100%;
}

.menu-section-name {
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: var(--qrw-content-base-inverse-tertiary);
}

.version-container {
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  row-gap: 0;

  justify-self: flex-end;
  position: absolute;
  bottom: 0;
}
</style>
